document.addEventListener('DOMContentLoaded', function() {
    // Select the .taxonomy-resource-type a element
    var resourceLink = document.querySelector('.taxonomy-resource-type a');
    
    if (resourceLink) {
        // Get the HTML content of the link
        var linkContent = resourceLink.innerHTML.trim();
        
        // Function to convert the content into a slug
        var createSlug = function(text) {
            return 'resource-type-' + 
                text
                .toLowerCase()
                .replace(/[^\w\s-]/g, '') // Remove special characters
                .replace(/\s+/g, '-')      // Replace spaces with hyphens
                .replace(/-+/g, '-');      // Replace multiple hyphens with a single hyphen
        };
        
        // Create the slug from the link content
        var slug = createSlug(linkContent);
        
        // Add the slug as a class to the body element
        document.body.classList.add(slug);
    }
});
